import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-reload-button-sm',
    templateUrl: './reload-button-sm.component.html',
    styleUrls: ['./reload-button-sm.component.scss'],
})
export class ReloadButtonSmComponent {
    @Input() isLoading: boolean;
    @Input() isActive: boolean;
    constructor() {} 
}